package de.oevbs.kunde.kundenportal2.model.services.registration

import de.oevbs.kunde.kundenportal2.validation.KupoValidationMessages
import de.oevbs.kunde.kundenportal2.validation.Regexes
import de.oevbs.sfa.data.REGEX_EMAIL
import dev.fritz2.core.Lenses
import dev.fritz2.headless.validation.ComponentValidationMessage
import dev.fritz2.headless.validation.errorMessage
import dev.fritz2.validation.Validation
import dev.fritz2.validation.validation
import kotlinx.serialization.Serializable

@Lenses
@Serializable
data class RegistrationMail(
    val mail: String = "",
    val mailRepeat: String = "",
    val privacyTermsAccepted: Boolean = false,
) {
    companion object {
        val validation =
            validation<RegistrationMail, Unit, ComponentValidationMessage> { inspector, _ ->

                val email = inspector.map(RegistrationMail.mail())
                if (email.data.isEmpty()) {
                    add(email.errorMessage(KupoValidationMessages.EMPTY_INPUT))
                } else if (!REGEX_EMAIL.toRegex().matches(email.data)) {
                    add(email.errorMessage(KupoValidationMessages.NO_MATCH_HELP))
                }

                val emailRepeat = inspector.map(RegistrationMail.mailRepeat())
                if (emailRepeat.data.isEmpty()) {
                    add(emailRepeat.errorMessage("Bitte wiederholen Sie Ihre Mail-Adresse."))
                } else if (emailRepeat.data != email.data) {
                    add(emailRepeat.errorMessage("Die Mail-Adressen stimmen nicht überein."))
                }

                val terms = inspector.map(RegistrationMail.privacyTermsAccepted())
                if (!terms.data) {
                    add(terms.errorMessage("Sie müssen den Nutzungsbedingungen zustimmen."))
                }
            }
    }
}

@Lenses
@Serializable
data class RegistrationUser(
    val token: String = "",
    val username: String = "",
    val password: String = "",
    val passwordRepeat: String = ""
) {
    companion object {
        val validation: Validation<RegistrationUser, Unit, ComponentValidationMessage> =
            validation { inspector, _ ->

                val user = inspector.map(RegistrationUser.username())
                if (user.data.isEmpty()) {
                    add(user.errorMessage("Bitte geben Sie den gewünschten Benutzernamen ein."))
                } else if (!Regexes.userName.matches(user.data)) {
                    add(user.errorMessage(KupoValidationMessages.NO_MATCH_HELP))
                }

                val pass = inspector.map(RegistrationUser.password())
                if (pass.data.isEmpty()) {
                    add(pass.errorMessage(KupoValidationMessages.EMPTY_INPUT))
                } else if (!Regexes.password.matches(pass.data)) {
                    add(pass.errorMessage(KupoValidationMessages.NO_MATCH_HELP))
                } else if (user.data.isNotEmpty() && pass.data.contains(user.data)) {
                    add(pass.errorMessage("Ihr Passwort darf nicht Ihren Benutzernamen enthalten - klicken Sie auf das Fragezeichen, um Hilfe zu erhalten."))
                }

                val passRepeat = inspector.map(RegistrationUser.passwordRepeat())
                if (passRepeat.data.isEmpty()) {
                    add(passRepeat.errorMessage("Bitte wiederholen Sie Ihr Passwort."))
                } else if (passRepeat.data != pass.data) {
                    add(passRepeat.errorMessage("Die Passwörter stimmen nicht überein."))
                }
            }
    }
}